import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { loginMerchant } from "../../api/merchantAuthApi";
import "./login.scss";

const MerchantIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 10.5V20h16v-9.5" />
    <path d="M3 10.5 5.2 4h13.6l2.2 6.5" />
    <path d="M3 10.5a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 3-2.45" />
    <path d="M9 20v-5h6v5" />
  </svg>
);

const LockIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="5" y="10" width="14" height="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    <path d="M12 14v2" />
  </svg>
);

const LoginPage = () => {
  const [merchantCode, setMerchantCode] = useState("");
  const [phone, setPhone] = useState("60");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const clearError = () => setErrorMessage("");

  const handleLogin = async (event) => {
    event.preventDefault();

    if (!merchantCode.trim() || !phone || phone.length < 8 || !password) {
      setErrorMessage("Please enter your merchant code, phone number, and password.");
      return;
    }

    setSubmitting(true);
    try {
      await loginMerchant({ merchantCode, phone, password });
      window.location.replace("/");
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__brand">
          <span>SB</span>
          <strong>SecondBite</strong>
          <small>Merchant Portal</small>
        </div>

        <h1 className="login-page__title">Welcome Back</h1>
        <p className="login-page__subtitle">
          Log in using your merchant code, registered phone number, and password.
        </p>

        <form className="login-page__form" onSubmit={handleLogin}>
          <div className="login-page__field">
            <span className="login-page__icon">
              <MerchantIcon />
            </span>
            <input
              className="login-page__input"
              type="text"
              name="merchantCode"
              placeholder="Merchant Code"
              value={merchantCode}
              autoComplete="organization"
              aria-label="Merchant code"
              onChange={(event) => {
                setMerchantCode(event.target.value.toUpperCase());
                clearError();
              }}
            />
          </div>

          <div className="login-page__phone">
            <PhoneInput
              country="my"
              preferredCountries={["my", "sg", "bn", "id"]}
              enableSearch
              countryCodeEditable={false}
              value={phone}
              onChange={(value) => {
                setPhone(value);
                clearError();
              }}
              inputProps={{
                name: "phone",
                required: true,
                autoComplete: "tel",
                "aria-label": "Phone number",
              }}
            />
          </div>

          <div className="login-page__field">
            <span className="login-page__icon">
              <LockIcon />
            </span>
            <input
              className="login-page__input"
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              autoComplete="current-password"
              aria-label="Password"
              onChange={(event) => {
                setPassword(event.target.value);
                clearError();
              }}
            />
          </div>

          {errorMessage && (
            <div className="login-page__message login-page__message--error">
              {errorMessage}
            </div>
          )}

          <button type="submit" className="login-page__submit" disabled={submitting}>
            {submitting ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>

      <div className="login-page__wave login-page__wave--one" />
      <div className="login-page__wave login-page__wave--two" />
    </div>
  );
};

export default LoginPage;
